module.exports = __webpack_public_path__ + "static/media/icon_add-tag.0fda936d.svg";